import { createAction, createAsyncAction } from 'typesafe-actions';
import { ErrorMessage, Entry, Voyage } from '../../services/types';


export const selectShip = createAsyncAction(
  'SELECT_SHIP_REQUEST',
  'SELECT_SHIP_SUCCESS',
  'SELECT_SHIP_FAILURE'
)<string, Voyage[], ErrorMessage>();

export const selectVoyage = createAsyncAction(
  'SELECT_VOYAGE_REQUEST',
  'SELECT_VOYAGE_SUCCESS',
  'SELECT_VOYAGE_FAILURE'
)<string, Entry[], ErrorMessage>();

export const loadPositionsSuccess = createAction('LOAD_POSITIONS_SUCCESS')<any>();
export const loadEntries = createAction('LOAD_ENTRIES')<string>();
export const setSelectedYear = createAction('SET_SELECTED_YEAR')<string>();


